<template>
  <section>
    <p v-if="displayError" class="error-box"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{ displayError }}</p>
    <div v-if="isLoading" class="loading-spinner">
      <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
    </div>
    <section v-if="findocs">
      <table class="table">
        <thead>
          <tr>
            <th>
              datum vystavení
            </th>
            <th class="money">
              částka
            </th>
            <th>
              popis
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in findocs" :key="item.id">
            <td>
              {{ human_readable_date(item.dIssue) }}
            </td>
            <td class="money">
              {{ prachy(item.value) }}
            </td>
            <td>
              <a :href="'/api/findocs/'+item.id">
              <span v-if="item.is_invoice">faktura</span>
              <span v-if="item.is_payadvice">předpis plateb</span>
              <span v-if="item.is_debt_reminder" class="label-debt-reminder">upomínka plateb</span>
              č. {{ item.id }}
              </a>
              pro: {{ item.to.name }}, {{ item.to.address }}, {{ item.to.city }}
              <div v-if="item.sent.email" class="grey">
                odesláno {{ human_readable_date_time(item.sent.email) }} na e-mail {{ item.sent.emailTo }}
              </div>
              <div v-if="item.sent.printed" class="grey">
                odesláno {{ human_readable_date(item.sent.printedDate) }} poštou na adresu {{ item.sent.printedAddr }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </section>
  </section>
</template>

<script>
import FindocResource from '../backend-resources/findoc-resource'
import moment from 'moment'

export default {
  name: 'my-findocs',
  data () {
    return {
      findocs: null,
      displayError: null,
      isLoading: false
    }
  },
  created: function () {
    this.isLoading = true
    FindocResource.get().then((response) => {
      this.findocs = response.data
      this.displayError = null
      this.isLoading = false
    }).catch((error) => {
      this.findocs = null
      this.displayError = error.response.status + ' ' + error.response.statusText
      this.isLoading = false
    })
  },
  methods: {
    human_readable_date: function (yyyymmdd) {
      let m = moment(yyyymmdd)
      return m.isValid() ? m.format('D.M.Y') : yyyymmdd
    },
    human_readable_date_time: function (timestamp) {
      let m = moment(timestamp)
      return m.isValid() ? m.format('D.M.Y HH:mm') : timestamp
    },
    prachy: function (kolik) {
      if (kolik === null) {
        return ''
      }
      kolik = parseFloat(kolik)
      return kolik.toFixed(2)
    }
  }
}
</script>

<style>
.money {
  text-align: right;
}
.highlight {
  color:#538ebe;
}
.grey {
  color: grey;
}
.label-debt-reminder {
  color: orange;
}
</style>



// WEBPACK FOOTER //
// MyFindocs.vue?4b13cb43